import { useCrumbs } from "@/components/layout/CrumbsContext";
import { ReportingView } from "@/components/plan-audit/ReportingView";

export function ReportingPage() {
  useCrumbs([{ label: "Reporting" }, { label: "Solution output quality" }]);
  return (
    <>
      <div className="pa-page-head">
        <div>
          <h1>Solution output quality</h1>
          <p>
            First-pass quality across every audited plan — the score before anyone edited it — and
            what the evidence says to change in the Solution tool.
          </p>
        </div>
      </div>
      <ReportingView />
    </>
  );
}
